module.exports = "<section class=\"not-found\">\r\n  <div class=\"not-found-container\">\r\n    <h1>404 Not Found</h1>\r\n    <h4>Whoops!</h4>\r\n    <p>We can't seem to find the page you are looking for.</p>\r\n    <button routerLink=\"\" class=\"rod-btn party-btn\">Back to Home</button>\r\n  </div>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main